import { Button, Col, Form, Input, Modal, Row, Typography } from 'antd'
import styled from 'styled-components'
import { Icon } from 'src/components/common/icons'
import useAuth from 'src/store/hooks/authentication'

export const ModalStyled = styled(Modal)`
  border-radius: 20px;
  color: #ffffff;

  .ant-modal-content {
    background: #13151d;
    max-width: 600px;
    height: auto;
  }

  ::placeholder {
    color: #757575;
    font-size: 14px;
    font-weight: 400;
  }
`
export const LoginPage = (props) => {
  const { actions } = useAuth()

  const onSubmitLogin = (values) => {
    const body = {
      username: values.username,
      password: values.password,
    }
    actions.login({ body, onSuccess: () => props.setOpenSignIn(false), onError: () => props.setOpenSignIn(false) })
  }

  const handleClickRegister = () => {
    props.setOpenSignUp(true)
    props.setOpenSignIn(false)
  }

  return (
    <ModalStyled
      open={props.open}
      closable={true}
      onCancel={() => props.setOpenSignIn(false)}
      footer={null}
      wrapClassName="!bg-[#00000070]"
      className="relative"
    >
      <Row gutter={24}>
        <Col span={24} className="text-center">
          <Typography.Text className="text-base font-bold !text-[#7D8091]">
             Đăng nhập
          </Typography.Text>
        </Col>
        <Col span={24} className="mt-4 z-10 w-full flex justify-center">
          <Form onFinish={onSubmitLogin} className='w-full max-w-[400px]'>
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Tên đăng nhập không được để trống',
                },
              ]}
            >
              <Input
                className="bg-[#181C28] p-4 text-white"
                placeholder="Tên đăng nhập"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Mật khẩu không được để trống',
                },
                {
                  min: 8,
                  message: 'Mật khẩu tối thiểu phải chứa 8 kí tự',
                },
              ]}
            >
              <Input
                className="bg-[#181C28] p-4 text-white"
                placeholder="Mật khẩu"
                type="password"
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full h-10 bg-custom-gradient text-[#F3F3F3] text-base mt-2"
            >
              Đăng nhập
            </Button>
          </Form>
        </Col>
        <Col span={24} className="mt-1.5 flex justify-center">
          <Typography.Text
            className="text-[#F3F3F3] text-sm font-normal cursor-pointer z-10 mt-2"
            onClick={handleClickRegister}
          >
            Bạn chưa có tài khoản? Đăng ký
          </Typography.Text>
        </Col>
        <Icon name="login" className="absolute top-0 right-0" />
      </Row>
    </ModalStyled>
  )
}
